// @flow
import axios from "../axios";

export const getCourses = async () => {
  return await axios.get("/api/courses");
};



// WEBPACK FOOTER //
// ./src/utils/api/course.js